<template>
    <div class="card">
        <div class="card-content">
            <div class="field has-addons">
                <div class="control is-expanded">
                    <tags-input
                            element-id="models"
                            placeholder="Type model name and press enter."
                            v-model="models"
                            :existing-tags="existingModels"
                            :typeahead="true"
                            :typeahead-activation-threshold="0">
                    </tags-input>
                </div>
                <div class="control">
                    <button class="button is-primary is-medium" @click="searchModels">
                        Search
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import tagsInput from '@voerro/vue-tagsinput';
    import apiAuctions from '../../../api/apiAuctions'
    export default {
        components: {
            tagsInput: tagsInput
        },
        data () {
           return {
               existingModels: {}
           }
        },
        computed: {
            models: {
                get: function () {
                    return this.$store.getters.getQueryModels
                },
                set: function (values) {
                    this.$store.dispatch('handleQueryModels', values)
                }
            },
            totalLotsFound () {
                return this.$store.getters.getTotalLots
            }
        },
        methods: {
            removeModelFromQuery (model) {
                this.$store.dispatch('removeModelFromQuery', model)
                this.$store.dispatch('fetchResults')
            },
            searchModels() {
                this.$store.dispatch('fetchResults')
            }
        },
        mounted () {
            const brand = this.$store.getters.getQueryCompanyId
            apiAuctions.
            getModelsByBrandName(brand)
                .then((response) => {
                    const obj = {};
                    for (const key of response.data) {
                        obj[key] = key;
                    }
                    this.existingModels = obj
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }
</script>

<style scoped>
    .card {
        margin-bottom: 25px;
    }
    input:focus {
        outline:none;
    }
    #models{
        height: 100%;
    }
    .tags-input input{
        height: 100% !important;
        width: 250px !important;
        border-style: none !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Results/SelectModels.vue